'use strict';

function controller ($scope, dealerChatService, viewport, activeEngage, pageStateService, leadFormService) {
    const ctrl = this;

    ctrl.showButton = false;
    ctrl.buttonEnabled = false;
    ctrl.showDealerInspireButton = false;

    ctrl.$onInit = function () {
        if (dealerChatService.isActiveEngageEnabled()) {
            ctrl.buttonEnabled = activeEngage.isActiveEngageReady();
            ctrl.showButton = true;

            $scope.$on(activeEngage.activeEngageReadyEvent, () => {
                ctrl.buttonEnabled = true;
                ctrl.activated = true;
            });
        } else {
            ctrl.buttonEnabled = true;
            if (ctrl.isDealerInspire && !viewport.isMobile()) {
                ctrl.showDealerInspireButton = true;
                ctrl.showButton = false;
            } else {
                dealerChatService.isDealerOnline(ctrl.customerId).then(function(isOnline) {
                    if (isOnline && !viewport.isMobile()) {
                        ctrl.showButton = true;
                    }
                    ctrl.activated = true;
                });
        }
        }
    };

    ctrl.openChat = function () {
        if (dealerChatService.isActiveEngageEnabled()) {
            let payload = {};

            payload.listingId = ctrl.listingId;
            payload.vehicleMake = ctrl.makeName;
            payload.vehicleModel = ctrl.modelName;
            payload.vehicleYear = ctrl.modelYear;
            payload.vehicleStockNumber = ctrl.stockNumber;
            payload.vehicleVin = ctrl.vin;
            payload.advertiserId = ctrl.customerId;

            activeEngage.launchChat(payload);
        }
        dealerChatService.fireChatPageStateEvent();
    };

    ctrl.openEmbeddedChat = function () {
        leadFormService.setDefaultToChatTab(true);
    };

}

controller.$inject = ['$scope', 'dealerChatService', 'viewport', 'activeEngage', 'pageStateService', 'leadFormService'];

export default controller;
